<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <v-flex xs12>
            <v-textarea
              label="大事记内容"
              :rules="rules.required"
              counter="1000"
              v-model="item.summary"
            />
          </v-flex>
        </v-form>

      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" @click.native="onSave">保存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

  import mixin from '@/mixin'

  const baseURI = '/api/proj/event';

  export default {
    mixins: [mixin.edit(baseURI)],
    props: ['value', 'uri', "dbid", 'projectId'],

    data() {
      return {
        formValid: false,

        item: {},
        freshItem: {
          projectId: null,
          summary:null
        },

        /**
         * 验证规则
         */
        rules: {
          required: [
            v => (!!v) || '必填项。',
            v => (v && v.length < 1000) || '最多填 1000 字符。'
          ]
        }
      }
    },

    methods: {
      // mixin 加载数据后调用
      afterGetData(data) {},

      beforeSendData(data) {
        //console.log("in beforeSendData");
        data.projectId = this.projectId;
      }
    }
  }
</script>
